import { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
const STATUS_LABEL = { open: 'Открыт', closed: 'Закрыт' };

function fmtDate(str) {
  if (!str) return '';
  const d = new Date(str);
  return d.toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function Support() {
  const [tickets, setTickets] = useState(null);
  const [view, setView] = useState('list'); // 'list' | 'new' | ticketId
  const [ticket, setTicket] = useState(null);
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [reply, setReply] = useState('');
  const [err, setErr] = useState('');
  const [sending, setSending] = useState(false);

  const headers = { Authorization: 'Bearer ' + localStorage.getItem('clinicToken') };

  const loadList = () => axios.get(`${API}/clinic-cabinet/support/tickets`, { headers }).then(r => setTickets(r.data));
  const loadTicket = (id) => axios.get(`${API}/clinic-cabinet/support/tickets/${id}`, { headers }).then(r => setTicket(r.data));

  useEffect(() => { loadList(); }, []); // eslint-disable-line

  const openTicket = (id) => { setView(id); loadTicket(id); };
  const backToList = () => { setView('list'); setTicket(null); loadList(); };

  const createTicket = async () => {
    setErr('');
    if (!subject.trim() || !body.trim()) { setErr('Заполните тему и сообщение'); return; }
    setSending(true);
    try {
      const r = await axios.post(`${API}/clinic-cabinet/support/tickets`, { subject, body }, { headers });
      setSubject(''); setBody('');
      openTicket(r.data.id);
    } catch (e) { setErr(e?.response?.data?.detail || 'Не удалось создать тикет'); }
    setSending(false);
  };

  const sendReply = async () => {
    if (!reply.trim()) return;
    setSending(true);
    try {
      await axios.post(`${API}/clinic-cabinet/support/tickets/${ticket.id}/messages`, { body: reply }, { headers });
      setReply('');
      await loadTicket(ticket.id);
    } catch (e) { setErr(e?.response?.data?.detail || 'Не удалось отправить'); }
    setSending(false);
  };

  const closeTicket = async () => {
    await axios.post(`${API}/clinic-cabinet/support/tickets/${ticket.id}/close`, {}, { headers });
    loadTicket(ticket.id);
  };

  if (view === 'new') {
    return (
      <Layout>
        <h1 style={s.h1}>Новый тикет</h1>
        <div style={s.card}>
          <label style={s.label}>Тема</label>
          <input style={s.input} value={subject} onChange={e => setSubject(e.target.value)} placeholder="Коротко опишите вопрос" />
          <label style={s.label}>Сообщение</label>
          <textarea style={s.textarea} value={body} onChange={e => setBody(e.target.value)} placeholder="Опишите проблему подробнее" rows={6} />
          {err && <div style={s.err}>{err}</div>}
          <div style={s.actions}>
            <button style={s.btnGhost} onClick={backToList}>Отмена</button>
            <button style={s.btn} onClick={createTicket} disabled={sending}>{sending ? 'Отправка…' : 'Создать тикет'}</button>
          </div>
        </div>
      </Layout>
    );
  }

  if (view !== 'list') {
    if (!ticket) return <Layout><div style={s.empty}>Загрузка…</div></Layout>;
    return (
      <Layout>
        <div style={s.threadHeader}>
          <button style={s.backBtn} onClick={backToList}>← Все тикеты</button>
          <span style={{ ...s.badge, ...(ticket.status === 'open' ? s.badgeTeal : s.badgeGray) }}>{STATUS_LABEL[ticket.status]}</span>
        </div>
        <h1 style={s.h1}>{ticket.subject}</h1>
        <div style={s.thread}>
          {ticket.messages.map(m => (
            <div key={m.id} style={{ ...s.bubble, ...(m.sender_role === 'admin' ? s.bubbleAdmin : s.bubbleUser) }}>
              <div style={s.bubbleMeta}>{m.sender_role === 'admin' ? 'Техподдержка' : 'Вы'} · {fmtDate(m.created_at)}</div>
              <div style={s.bubbleBody}>{m.body}</div>
            </div>
          ))}
        </div>
        <div style={s.card}>
          <textarea style={s.textarea} value={reply} onChange={e => setReply(e.target.value)} placeholder="Ваш ответ…" rows={3} />
          {err && <div style={s.err}>{err}</div>}
          <div style={s.actions}>
            <button style={s.btnGhost} onClick={closeTicket}>{ticket.status === 'open' ? 'Закрыть тикет' : 'Тикет закрыт'}</button>
            <button style={s.btn} onClick={sendReply} disabled={sending}>{sending ? 'Отправка…' : 'Отправить'}</button>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div style={s.header}>
        <h1 style={s.h1}>Техподдержка</h1>
        <button style={s.btn} onClick={() => { setErr(''); setView('new'); }}>+ Новый тикет</button>
      </div>
      <div style={s.tableCard}>
        {!tickets ? <div style={s.empty}>Загрузка…</div> : tickets.length === 0 ? (
          <div style={s.empty}>Тикетов пока нет — если есть вопрос, создайте новый.</div>
        ) : tickets.map(t => (
          <div key={t.id} style={s.row} onClick={() => openTicket(t.id)}>
            <div style={s.rowMain}>
              <div style={s.rowSubject}>{t.subject}</div>
              <div style={s.rowMeta}>{fmtDate(t.last_message_at)}</div>
            </div>
            <div style={s.rowRight}>
              {t.status === 'open' && t.last_message_role === 'admin' && <span style={s.waitTag}>Ждём вашего ответа</span>}
              <span style={{ ...s.badge, ...(t.status === 'open' ? s.badgeTeal : s.badgeGray) }}>{STATUS_LABEL[t.status]}</span>
            </div>
          </div>
        ))}
      </div>
    </Layout>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 },
  h1: { color: '#1B2B4B', fontSize: 28, fontWeight: 800, margin: '0 0 20px' },
  tableCard: { background: '#fff', borderRadius: 16, padding: '8px 8px', boxShadow: '0 4px 16px rgba(27,43,75,0.06)' },
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 16px', borderBottom: '1px solid #f4f7fb', cursor: 'pointer' },
  rowMain: { display: 'flex', flexDirection: 'column', gap: 4 },
  rowSubject: { color: '#1B2B4B', fontWeight: 600, fontSize: 15 },
  rowMeta: { color: '#94a3b8', fontSize: 12 },
  rowRight: { display: 'flex', alignItems: 'center', gap: 10 },
  waitTag: { color: '#d97706', fontSize: 12, fontWeight: 600 },
  badge: { padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 },
  badgeTeal: { background: '#e9faf7', color: '#149e90' },
  badgeGray: { background: '#f1f5f9', color: '#64748b' },
  empty: { color: '#94a3b8', textAlign: 'center', padding: '32px 0', fontSize: 14 },
  card: { background: '#fff', borderRadius: 16, padding: 24, boxShadow: '0 4px 16px rgba(27,43,75,0.06)', display: 'flex', flexDirection: 'column', gap: 6, marginTop: 16 },
  label: { color: '#64748b', fontSize: 13, fontWeight: 600, marginTop: 8 },
  input: { background: '#F6F8FB', border: '1px solid #d7dee8', borderRadius: 10, padding: '10px 14px', fontSize: 14, color: '#1B2B4B', outline: 'none' },
  textarea: { background: '#F6F8FB', border: '1px solid #d7dee8', borderRadius: 10, padding: '10px 14px', fontSize: 14, color: '#1B2B4B', outline: 'none', resize: 'vertical', fontFamily: 'inherit' },
  err: { color: '#dc2626', fontSize: 13 },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 },
  btn: { background: '#2EC4B6', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', border: '1px solid #d7dee8', color: '#64748b', borderRadius: 10, padding: '10px 20px', fontSize: 14, cursor: 'pointer' },
  threadHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 },
  backBtn: { background: 'transparent', border: 'none', color: '#149e90', fontSize: 13, cursor: 'pointer', fontWeight: 600, padding: 0 },
  thread: { display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 16 },
  bubble: { maxWidth: '70%', borderRadius: 14, padding: '12px 16px' },
  bubbleUser: { background: '#e9faf7', alignSelf: 'flex-end' },
  bubbleAdmin: { background: '#fff', boxShadow: '0 4px 16px rgba(27,43,75,0.06)', alignSelf: 'flex-start' },
  bubbleMeta: { color: '#94a3b8', fontSize: 11, marginBottom: 4 },
  bubbleBody: { color: '#1B2B4B', fontSize: 14, whiteSpace: 'pre-wrap' },
};
